import React from 'react'

function Alert({ text }) {
    return <div className="alert alert-success text-center">{text}</div>
}

export default Alert
